"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactIntl = require("react-intl");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("@cimpress/react-components/lib/Button"));

var _rulesetConstraintEditors = require("@cimpress-technology/ruleset-constraint-editors");

var _dataSheetSummary = _interopRequireDefault(require("./dataSheetSummary"));

var _propTypes2 = require("../shared/propTypes");

var _messages = _interopRequireDefault(require("./messages"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var DataSheetsContainer = function DataSheetsContainer(_ref) {
  var dataSheets = _ref.dataSheets,
      options = _ref.options,
      updateDataSheets = _ref.updateDataSheets,
      onDelete = _ref.onDelete;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      dataSheetsEditMode = _useState2[0],
      setDataSheetsEditMode = _useState2[1];

  var toggleEditDataSheets = function toggleEditDataSheets() {
    setDataSheetsEditMode(!dataSheetsEditMode);
  };

  return (
    /*#__PURE__*/
    _react["default"].createElement(_react.Fragment, null, dataSheetsEditMode &&
    /*#__PURE__*/
    _react["default"].createElement(_react.Fragment, null,
    /*#__PURE__*/
    _react["default"].createElement(_Button["default"], {
      type: "primary",
      onClick: toggleEditDataSheets
    }, formatMessage(_messages["default"].backToDataSheetsSummary)),
    /*#__PURE__*/
    _react["default"].createElement(_rulesetConstraintEditors.ProductDataSheetsEditor, {
      options: Object.values(options),
      dataSheets: dataSheets,
      onDataSheetsChanged: updateDataSheets
    })), !dataSheetsEditMode && (dataSheets.length ? dataSheets.map(function (dataSheet, index) {
      return (
        /*#__PURE__*/
        _react["default"].createElement(_dataSheetSummary["default"], {
          key: "".concat(dataSheet.name, ": ").concat(index),
          dataSheet: dataSheet,
          deleteKey: index,
          options: options,
          onDelete: onDelete,
          onEdit: toggleEditDataSheets
        })
      );
    }) :
    /*#__PURE__*/
    _react["default"].createElement("div", null, formatMessage(_messages["default"].noDataSheetsConfigured))))
  );
};

DataSheetsContainer.propTypes = {
  dataSheets: _propTypes["default"].arrayOf(_propTypes["default"].shape(_propTypes2.dataSheetsShape)),
  options: _propTypes["default"].objectOf(_propTypes["default"].shape(_propTypes2.optionShape)).isRequired,
  updateDataSheets: _propTypes["default"].func.isRequired,
  onDelete: _propTypes["default"].func.isRequired
};
var _default = DataSheetsContainer;
exports["default"] = _default;